export function userFlags(me, flag) {
  return !(!me || !me.flags[flag]);
}
